import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from './../pipes/pipes.module';
import { GrowthPercentageComponent } from './growth-percentage/growth-percentage.component';
import { TableColumnComponent } from './table-column/table-column.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule
  ],
  declarations: [
    TableColumnComponent,
    GrowthPercentageComponent
  ],
  exports: [
    TableColumnComponent,
    GrowthPercentageComponent
  ]
})
export class TableModule { }
